import auth from "../../middlewares/auth";

export const cloudIamRoutes = [
    {
        path: '/cloud-iam',
        component: () => import(/* webpackChunkName: "services" */ '../../views/iam/IamTabIndex.vue'),
        name: 'cloud_iam',
        meta: {
            middleware: [
                auth
            ]
        }
    },
]